<script setup lang="ts">
interface FormSectionProps {
  disabled?: boolean;
  title?: string;
}

withDefaults(defineProps<FormSectionProps>(), {
  disabled: false,
  title: undefined,
});
</script>

<template>
  <v-sheet class="sheet" :class="{ disabled }">
    <div class="content" :class="{ 'disabled-content': disabled }">
      <slot name="header">
        <h5 v-if="title" class="mb-2">{{ title }}</h5>
      </slot>
      <slot></slot>
    </div>
  </v-sheet>
</template>

<style scoped lang="scss">
.content {
  width: 100%;
}

.sheet,
.content {
  transition: opacity 0.4s ease;
  opacity: 1;
}

.disabled {
  opacity: 0.4;
}
.disabled-content {
  opacity: 0.8;
}
</style>
